import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleDistributionChart = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="text-center py-8">
        <Icon name="PieChart" size={48} className="mx-auto mb-2 opacity-50 text-muted-foreground" />
        <p className="text-muted-foreground">No role distribution data available</p>
      </div>
    );
  }

  const totalCount = data?.reduce((sum, item) => sum + item?.count, 0);

  const colors = [
    'bg-blue-500',
    'bg-green-500',
    'bg-purple-500',
    'bg-orange-500',
    'bg-pink-500',
    'bg-teal-500',
    'bg-indigo-500',
    'bg-red-500'
  ];

  return (
    <div className="space-y-4">
      {/* Bar Chart */}
      <div className="space-y-3">
        {data?.map((item, index) => {
          const percentage = totalCount > 0 ? (item?.count / totalCount) * 100 : 0;
          const colorClass = colors?.[index % colors?.length];

          return (
            <div key={item?.roleName} className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-2">
                  <div className={`w-3 h-3 rounded-full ${colorClass}`}></div>
                  <span className="font-medium text-foreground">{item?.roleName}</span>
                </div>
                <span className="text-muted-foreground">
                  {item?.count} ({percentage?.toFixed(1)}%)
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${colorClass} transition-all duration-300`}
                  style={{ width: `${percentage}%` }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
      {/* Summary */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-foreground">Total Role Assignments</p>
            <p className="text-xs text-muted-foreground">Across all team members</p>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold text-foreground">{totalCount}</p>
            <p className="text-xs text-muted-foreground">{data?.length} unique roles</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleDistributionChart;